import { render, staticRenderFns } from "./ImageInformation.vue?vue&type=template&id=347c521a&scoped=true"
import script from "./ImageInformation.vue?vue&type=script&lang=ts"
export * from "./ImageInformation.vue?vue&type=script&lang=ts"
import style0 from "./ImageInformation.vue?vue&type=style&index=0&id=347c521a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c521a",
  null
  
)

export default component.exports